import IInitiativeSubmissionData from 'types/IInitiativeSubmissionData'
import { IUpdateInitiativeAnswer } from '../Interfaces'

export const initiativeManagementInitialState = {
  initiativeData: null as IInitiativeSubmissionData,
  isLoadingInitiative: false,
  validationError: false,
  isSubmittingInitiative: false,
  isWithdrawing: false,
  answers: {
    gpaValues: {
      graduateGpa: null,
      doesNotApplyForGraduateGpa: false,
      undergraduateGpa: null,
      doesNotApplyForUndergraduateGpa: false
    },
    questions: {}
  } as IUpdateInitiativeAnswer
}

export type InitiativeManagementState = typeof initiativeManagementInitialState
